var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aha-profanity-filter',{attrs:{"text":_vm.text,"filteringProfanity":!!_vm.$store.state.presentation.filteringProfanity}})
}
var staticRenderFns = []

export { render, staticRenderFns }